<template>
    <el-skeleton :rows="12" animated  v-if="loading"/>
    <div class="choose-goods" v-else>
        <h3 class="card-header">选择需预约的商品</h3>



        <div class="goods-list" v-if="goodsList.length > 0">
            <div v-for="item in goodsList" :key="item.id" class="goods-item" @click="handleReservation(item)">
                <div class="goods-img">
                    <el-image :src="mixinQiniuImg(item.goodsImg.split(',')[0], 100)" fit="fill" style="width: 100%; height: 100%;"></el-image>
                </div>
                <div class="goods-content">
                    <h3 class="goods-title">{{ item.name }}</h3>
                    <p class="goods-capacity">适用1 ~ {{ item.peopleNum }}人</p>
                    <div class="goods-footer">
                        <span class="util-money">¥ {{ $utils.getMinPrice(item) }}起</span>
                        <el-button type="primary" class="reserve-btn">立即预约</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="no-goods" v-else>
            <img src="@/assets/img/noGoods.png" alt="暂无商品" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChooseGoods',
    data() {
        return {
            loading: false,
            goodsList: []
        }
    },
    created() {
        this.getGoodsList()
    },
    methods: {
        // 获取商品列表
        async getGoodsList() {
            this.loading = true;
            let { code, data } = await this.$axios.get('/api/v1/manage/travelGoods', {status: 1});
            if (code == 1) {
                this.goodsList = data;
            }
            this.loading = false;
        },

        // 跳转到预约页面
        handleReservation(item) {
            this.$router.push({
                path: '/travelReservationForm',
                query: {
                    goodsId: item.id,
                    peopleNum: item.peopleNum,
                    reservationTime: item.reservationTime,
                    advanceReservationTime: item.advanceReservationTime
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.choose-goods {
    .card-header {
        margin-bottom: 20px;
    }

    .goods-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;
    }
    .reserve-btn {
        opacity: 0;
        transition: all 0.5s;
        transform: translateY(5px);
    }
    .goods-item {
        padding: 16px;
        border: 1px solid #eee;
        border-radius: 8px;
        overflow: hidden;
        transition: all 0.3s;
        cursor: pointer;
        display: flex;
        align-items: flex-start;

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            //   transform: translateY(-2px);
            .reserve-btn {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }
    .goods-img {
        width: 100px;
        height: 100px;
        border-radius: 8px;
        overflow: hidden;
    }

    .goods-content {
        margin-left: 10px;
        flex: 1;
        height: 100px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .goods-title {
        font-size: 16px;
        font-weight: bold;
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        word-break: break-all;
    }

    .goods-capacity {
        color: #999;
    }

    .goods-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .no-goods {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 90%;
    }
}
</style>
